import {useState, useEffect} from "react";

const useOrient = (storageId)=>{
    const [orientVisible, setVisible] = useState(localStorage.getItem(storageId) || true);

    const toggleOrient = (v)=>{
        setVisible(v);
        localStorage.setItem(storageId, false);
    }

    useEffect(() => {
      return () => {
          toggleOrient(false)
      }}, []);


    return {
        orientVisible,
        toggleOrient
    }
}

export default useOrient;